import axios from "axios";
import { BACKEND_URL } from "../utils/envConfig";

const API_URL = `${BACKEND_URL}/consumables`;

export const getAllConsumables = async () => {
  const response = await axios.get(`${API_URL}`);
  return response.data;
};

export default {
  getAllConsumables,
}